import { makePersistable } from 'mobx-persist-store';

const persistStore = <T extends Record<string, any>, P extends keyof T>(
  target: T,
  properties: P[],
  persistName: string,
): void => {
  makePersistable(
    target,
    {
      name: persistName,
      properties,
      storage: window.localStorage,
    },
    { fireImmediately: true },
  );
};

export default persistStore;
